// extracted by mini-css-extract-plugin
export var addButton = "styles-module--addButton--69943";
export var bottomBar = "styles-module--bottomBar--3f4d5";
export var closeButton = "styles-module--closeButton--6c921";
export var closeButtonContainer = "styles-module--closeButtonContainer--3ede7";
export var closeButtonIcon = "styles-module--closeButtonIcon--3135d";
export var container = "styles-module--container--f1933";
export var content = "styles-module--content--de78f";
export var desktop = "1340px";
export var fullPageButton = "styles-module--fullPageButton--f8530";
export var giant = "2200px";
export var isOpen = "styles-module--isOpen--f1377";
export var largeDesktop = "1600px";
export var largeMobile = "500px";
export var largeTablet = "1025px";
export var mobile = "400px";
export var mobileText = "styles-module--mobileText--5ae3f";
export var smallDesktop = "1260px";
export var smallMobile = "340px";
export var smallTablet = "660px";
export var tablet = "769px";
export var topBar = "styles-module--topBar--cfe3a";
export var totalSavings = "styles-module--totalSavings--70228";